import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  syncProfilePictures() {
    return axios.post(`${this.url}/sync_profile_pictures`);
  }
}

export default new Agents();
